export default {
    common: {
        meta: {
            title: 'CrispyVoice',
            subTitle: 'Die Stimme Deiner Zukunft'
        },
        mediums: {
            commercials: {
                title: 'Werbung',
                examples: 'TV, Plakatwände, YouTube und Radio'
            },
            'info-videos': {
                title: 'Info-Videos',
                examples: 'E-Learning, Produktvideo, Imagevideo'
            },
            'social-media': {
                title: 'Soziale Medien',
                examples: 'Facebook, YouTube, Instagram, TikTok'
            },
            public: {
                title: 'Öffentlich',
                examples: 'Feueralarm, Lautsprecheransagen, Amok-Alarm'
            },
            layout: {
                title: 'Layout'
            },
            'e-learning': {
                title: 'E-Learning',
                examples: 'Online-Kurse, Schulungsvideos, Tutorials'
            }
        },
        buttons: {
            cancel: 'Abbrechen',
            back: 'Zurück',
            submit: 'Absenden'
        },
        errors: {
            somethingWentWrong: 'Etwas ist schiefgelaufen!'
        },
        formats: {
            mp3: 'MP3',
            wav: 'WAV'
        },
        timeframes: {
            day_one: 'Tag',
            day_other: 'Tage',
            week_one: 'Woche',
            week_other: 'Wochen',
            month_one: 'Monat',
            month_other: 'Monate',
            year_one: 'Jahr',
            year_other: 'Jahre'
        },
        landing: {
            title: 'Stimme wählen',
            subtitle: 'Wähle eine der verfügbaren KI-Stimmen aus.'
        },
        'contact-speaker': 'Kontakt zu {{shortName}}',
        'api-contact-form-description':
            'Möchtest du dich direkt mit meiner KI-Stimme verbinden, ohne diese Website nutzen zu müssen?',
        'contact-form-instruction': 'Fülle bitte das Formular aus und ich melde mich so schnell wie möglich.',
        'api-contact-form-instruction': 'Dann fülle bitte das Formular aus und ich melde mich so schnell wie möglich.',
        'contact-form-description':
            'Hat meine KI-Stimme Deine Erwartungen nicht erfüllt? Nicht genug Emotionen? Du kannst auch mit meiner natürlichen Stimme arbeiten!',
        'email-invalid': 'Ungültige E-Mail-Adresse',
        'email-required': 'E-Mail ist erforderlich',
        'email-too-short': 'E-Mail ist zu kurz',
        'email-too-long': 'E-Mail ist zu lang',
        'navigate-to-home': 'Audio generieren'
    },
    'core-shop': {
        topbar: {
            'ai-vs-ai': 'Mit KI gegen KI',
            'voice-owner-approved': 'Voice Owner Approved',
            'ai-act-ready': 'AI Act Ready',
            'hybrid-voice': 'Hybrid Voice',
            'card-payment': 'Kreditkarten-Zahlung',
            languages: '25+ Sprachen'
        },
        nav: {
            login: 'Login',
            api: 'API anfragen',
            contact: 'Kontakt',
            theme: 'Hell/Dunkel umschalten'
        },
        hero: {
            'headline-main': 'Die erste lizenzierte KI-Stimme.',
            'headline-accent': 'Rechtssicher. AI-Act konform.',
            'compare-natural': 'Natural Voice',
            'compare-clone': 'Klonstimme / Alter Ego',
            'no-demos': 'Für diese Anmutung sind aktuell keine Hörbeispiele verfügbar.',
            'cta-clone': 'KI-Stimme kostenlos testen',
            'cta-natural': 'Natural Voice buchen',
            'why-title': 'Darum solltest du CrispyVoice wählen',
            'why-1': 'Voice Owner Approved',
            'why-2': 'Freigabedokument inklusive',
            'why-3': 'Rechtssicher nach Schweizer/EU-Recht',
            'why-4': 'AI Act konform',
            caption: 'Ohne Anmeldung · in Sekunden fertig · ab {{currency}} {{price}}'
        },
        voicings: {
            label: '{{count}} Voicings',
            title: 'Eine Stimme. Mehrere Verwendungszwecke.',
            subtitle: 'Wähle eine Stimme, teste sie und kaufe direkt – ganz ohne Account.'
        },
        demo: {
            title: 'Hör zuerst. Kauf dann.',
            subtitle: 'Gib deinen Text ein, generiere eine Vorschau und wähle danach den passenden Use Case.',
            generate: 'Generieren',
            generating: 'Generiert …',
            disclaimer:
                'ⓘ Vorschau mit Wasserzeichen. Die gekaufte Datei kommt ohne Wasserzeichen – mit Freigabedokument.',
            'no-voice-data': 'Für diese Stimme ist die Demo aktuell nicht verfügbar.'
        },
        usecase: {
            question: 'Wofür setzt du die Stimme ein?',
            subtitle: 'Dein Preis richtet sich nach dem Einsatzgebiet – nicht nach der Textlänge.',
            'price-from': 'ab {{currency}} {{price}}',
            free: 'Kostenlos'
        },
        checkout: {
            'excl-vat': 'exkl. MwSt.',
            'ai-act': 'AI Act konform',
            'takes-title': 'Deine Takes',
            'takes-note':
                'Der Preis wird für jede Aufnahme anhand der Gesamtzeichenzahl der dafür ausgewählten Takes berechnet.',
            buy: 'Jetzt bestellen',
            'summary-title': 'Zusammenfassung',
            'selected-takes': 'Ausgewählte Takes',
            'total-characters': 'Gesamtzeichen',
            'character-value': '{{count}} / {{included}} inkl.',
            'take-count_one': '{{count}} Take',
            'take-count_other': '{{count}} Takes',
            'recording-details_one': 'Aufnahme {{number}} · {{characters}} Zeichen · {{count}} Take',
            'recording-details_other': 'Aufnahme {{number}} · {{characters}} Zeichen · {{count}} Takes',
            'base-price-details':
                'Grundpreis {{currency}} {{price}} · {{included}} Zeichen inkl. · danach {{currency}} {{rate}} / Zeichen',
            'additional-price-details':
                '{{currency}} {{basePrice}} + {{characters}} Zeichen × {{currency}} {{rate}} = {{currency}} {{totalPrice}}',
            'remove-recording': 'Aufnahme {{number}} aus der Bestellung entfernen',
            medium: 'Medium',
            license: 'Lizenz',
            'base-price': 'Grundpreis',
            total: 'Gesamt'
        },
        order: {
            label: 'Jetzt generieren',
            intro: 'In 4 Schritten zur fertigen KI-Stimme: Generieren, Einsatzgebiet wählen, bezahlen, downloaden.',
            'progress-label': 'Bestellfortschritt',
            progress: 'Schritt {{current}} von {{total}} · {{step}}',
            steps: {
                generate: 'Generieren',
                use: 'Einsatzgebiet wählen',
                review: 'Zusammenfassung & bezahlen'
            },
            'voice-hint': 'Anmutung wählen – jederzeit anklickbar, jede klingt spürbar anders:',
            'takes-title': 'Wähle deine Takes',
            characters: '{{count}} Zeichen ausgewählt',
            recording: 'Aufnahme {{number}}',
            version: 'Version {{number}}',
            'character-short': 'Z.',
            'buy-take': 'kaufen',
            'delete-take': 'Take löschen',
            generated_zero: '{{count}} Versionen generiert',
            generated_one: '{{count}} Version generiert',
            generated_other: '{{count}} Versionen generiert',
            'price-from': 'ab {{currency}} {{price}}',
            price: '{{currency}} {{price}}',
            'to-use': 'Weiter zur Medienwahl',
            'to-review': 'Weiter zur Zusammenfassung',
            'use-subtitle': 'Deine Auswahl bestimmt Lizenzdauer und Preis.',
            'api-note': 'Suchst du eine Schnittstellen-Anbindung, z.B. für Voicebots?',
            'api-contact': 'Schnittstelle anfragen →',
            back: 'Zurück'
        },
        usp: {
            label: 'Warum Alter Ego von CrispyVoice',
            '1-title': 'Voice Owner Approved',
            '1-text': 'Freigabe-Zertifikat pro Datei inklusive. Rechtssicher. Punkt.',
            '2-title': 'AI Act Ready',
            '2-text': 'DSGVO-konform. EU AI Act konform. Kein juristisches Risiko für dich.',
            '3-title': 'Mehrere Voicings',
            '3-text': 'Jedes Medium bekommt seinen passenden Duktus. Jedes Voicing frei einsetzbar.',
            '4-title': 'Hybrid Voice',
            '4-text': 'Original oder Alter Ego buchbar. Du entscheidest, was du brauchst.'
        },
        testimonials: {
            label: 'Kundenstimmen'
        },
        cta: {
            title: 'Bereit? Und bitte!',
            subtitle: 'Jetzt testen, dann buchen. Keine Verpflichtung.',
            primary: 'Jetzt testen',
            secondary: 'Natural Voice anfragen'
        },
        'natural-booking': {
            title: 'Natural Voice Buchung',
            subtitle: 'Professionelle Live-Aufnahme mit {{speaker}}',
            close: 'Dialog schließen',
            'selected-speaker': 'Ausgewählter Sprecher',
            name: 'Name',
            'name-placeholder': 'Max Mustermann',
            email: 'E-Mail',
            'email-placeholder': 'max@firma.de',
            company: 'Firma / Organisation',
            'company-placeholder': 'Meine Firma GmbH',
            street: 'Straße',
            'street-placeholder': 'Musterstraße',
            'street-nr': 'Nr.',
            'street-nr-placeholder': '123',
            zip: 'PLZ',
            'zip-placeholder': '12345',
            city: 'Ort',
            'city-placeholder': 'Berlin',
            country: 'Land',
            medium: 'Medium / Verwendungszweck',
            'select-placeholder': 'Bitte wählen...',
            countries: {
                DE: 'Deutschland',
                AT: 'Österreich',
                CH: 'Schweiz',
                LI: 'Liechtenstein',
                LU: 'Luxemburg',
                FR: 'Frankreich',
                IT: 'Italien',
                NL: 'Niederlande',
                BE: 'Belgien',
                GB: 'Vereinigtes Königreich',
                US: 'Vereinigte Staaten',
                OTHER: 'Sonstiges'
            },
            media: {
                podcast: 'Podcast',
                youtube: 'YouTube Video',
                commercial: 'Werbung / Commercial',
                audiobook: 'Hörbuch / Audiobook',
                elearning: 'E-Learning / Training',
                imagefilm: 'Imagefilm',
                social: 'Social Media',
                other: 'Sonstiges'
            },
            file: 'Text / Skript hochladen',
            'file-select': 'Datei auswählen',
            'file-hint': 'TXT, DOC, DOCX, PDF (max. 10 MB)',
            'file-remove': 'Entfernen',
            message: 'Nachricht / Projektdetails',
            'message-placeholder': 'Beschreibe dein Projekt: gewünschte Tonalität, Deadlines, Besonderheiten...',
            submit: 'Anfrage senden',
            submitting: 'Wird gesendet...',
            'success-title': 'Anfrage erfolgreich gesendet!',
            'success-message': 'Wir melden uns innerhalb von 24 Stunden bei dir.',
            errors: {
                'file-size': 'Die Datei ist zu groß (max. 10 MB).',
                'file-type': 'Ungültiger Dateityp. Erlaubt sind TXT, DOC, DOCX und PDF.',
                send: 'Die Anfrage konnte nicht gesendet werden. Bitte versuche es erneut.'
            }
        },
        footer: {
            left: 'CrispyVoice GmbH · Hünenberg, Schweiz · Mit KI, gegen KI.'
        }
    },
    hero: {
        title: 'Deine KI-Stimme. Direkt vom Sprecher. Rechtssicher. Punkt.',
        subTitle:
            'In 4 Schritten zur fertigen KI-Stimme: Einsatzgebiet wählen, generieren, bezahlen, downloaden. ✓ Freigabe inklusive.',
        'listen-to-my-voice': 'Anhören!',
        'voice-demo': {
            natural: 'Natürliche Stimme',
            clone: 'Klon-Stimme',
            'book-natural': 'Natural Voice buchen',
            'book-clone': 'Clone Voice buchen'
        },
        'read-full-testimonial': 'Vollständiges Testimonial lesen',
        reviews: 'Bewertungen'
    },
    testimonials: {
        title: 'Was Kunden über meine KI-Stimme sagen'
    },
    'medium-selection': {
        header: 'Wofür brauchst du meine KI-Stimme?',
        'price-from': 'ab {{currency}} {{basePrice}}',
        'price-free': 'kostenlos',
        'included-characters': '{{included}} Zeichen inklusive',
        'price-additional-characters': '{{currency}} {{price}} / zusätzliches Zeichen',
        'unrestricted-usage': 'Unbefristete Lizenz',
        'restricted-usage': '{{value}} $t(common:timeframes.{{unit}}, { "count": {{value}} }) Lizenz',
        api: {
            title: 'Schnittstelle',
            subTitle: 'auf Anfrage'
        }
    },
    'claim-account': {
        alreadyClaimed: 'Du hast dein Konto bereits am {{date}} beansprucht.',
        pleaseLogin: 'Bitte melde dich hier an:',
        login: 'Anmelden',
        setPasswordInstruction: 'Du musst nur noch ein Passwort festlegen, um dein Konto zu erhalten.',
        getAccount: 'Konto erhalten',
        password: 'Passwort',
        repeatPassword: 'Passwort wiederholen'
    },
    download: {
        title: 'Bestellt. Generiert. Fertig!',
        thanks: 'Vielen Dank, dass du meine Stimme für dein Projekt gewählt hast!',
        'download-ready-soon':
            'Deine KI-Audio-Datei wird gerade erstellt und ist in wenigen Minuten bereit zum Download.',
        'details-sent': 'Bestellbestätigung an <strong>{{emailAddress}}</strong> gesendet.',
        'check-inbox': 'Download-Link folgt per E-Mail (Check auch Spam!)',
        'including-invoice': 'Rechnung, Auftragsnummer & Freigabedokument inklusive.',
        'secure-download-id': 'Sichere Download-ID',
        'download-ready': 'Audio bereit!',
        'download-ready-description': 'Deine Audio-Datei ist fertig zum Download',
        'order-more': 'Mehr bestellen',
        'claim-account': 'Account freischalten',
        'download-order': 'Herunterladen',
        'download-preparing': 'Dein Download wird vorbereitet. Dies wird einige Minuten dauern.',
        'error-preparing-download':
            'Beim Vorbereiten deines Downloads ist ein Fehler aufgetreten. Bitte kontaktiere den Support.',
        'create-account-instruction': 'Du kannst auch ein Konto erstellen. Es fehlt nur noch ein Passwort:',
        password: 'Passwort',
        'repeat-password': 'Passwort wiederholen',
        'account-created-successfully': 'Dein Konto wurde erfolgreich erstellt!',
        'open-account': 'Konto öffnen',
        'password-required': 'Passwort ist erforderlich',
        'password-min-length': 'Das Passwort muss mindestens {{min}} Zeichen lang sein',
        'password-repeat-required': 'Passwortbestätigung ist erforderlich',
        'passwords-dont-match': 'Passwörter stimmen nicht überein',
        'there-you-go': 'Und bitte!',
        'problem-support': 'Probleme?'
    },
    progress: {
        'starting-soon': 'Beginnt bald...',
        'queue-position': 'Position in der Warteschlange: {{position}}',
        generating: 'Audio generieren...',
        finalizing: 'Finalisierung...'
    },
    imprint: {
        title: 'Impressum',
        contact: 'Künstler kontaktieren',
        'contact-artist': 'Künstler kontaktieren',
        'contact-platform': 'CrispyVoice kontaktieren',
        'responsible-for-platform': 'Verantwortlich für Plattform',
        'contact-artist-description': 'Wenn du mich direkt kontaktieren möchtest, dann nutze bitte dieses Formular.',
        'contact-platform-description': 'Bei Fragen zur Plattform selbst, nutze bitte dieses Formular.'
    },
    'audio-generation': {
        header: 'Text eingeben. Generieren. Hören.',
        'copy-protection-info':
            'Der Voice-Tag im Hintergrund? Nur Preview-Wasserzeichen. Deine gekaufte Datei kommt natürlich ohne.',
        buttons: {
            generate: 'Generieren',
            'generate-audio': 'Audio generieren',
            'please-wait': 'Bitte warten...',
            cancel: 'Generierung abbrechen',
            stop: 'Stopp',
            play: 'Abspielen',
            'contact-support': 'Kontakt'
        },
        'autoplay-blocked': 'Audio ist bereit. Tippe zum Abspielen.',
        'text-placeholder': 'Text hier eingeben',
        'character-limit-exceeded-explanation-anonymous':
            'Dieser Text überschreitet das Limit von {{limit}} Zeichen. <0>Registriere dich mit deiner E-Mail-Adresse</0>, um längere Texte zu generieren.',
        'character-limit-exceeded-explanation':
            'Dieser Text überschreitet das Limit von {{limit}} Zeichen. Du möchtest noch längere Texte generieren? <0>Kontaktiere uns</0> und wir finden die passende Lösung für dich.',
        'character-limit-contact-topic': 'Anfrage zur Generierung längerer Texte',
        'character-limit-contact-description':
            'Beschreibe uns bitte die Länge und Menge der Texte, die du generieren möchtest. Wir melden uns bei dir.',
        'recording-name': 'Aufnahme {{position}}',
        'consent-required-title': 'Zustimmung erforderlich',
        'consent-required-message':
            'Wir benötigen Ihre Zustimmung zur Verwendung funktionaler Cookies, um Missbrauch zu verhindern und eine faire Nutzung unseres Dienstes zu gewährleisten.',
        'accept-cookies': 'Cookies akzeptieren',
        'anonymous-limit-reached-title': 'Mehr generieren? Und bitte!',
        'anonymous-limit-reached-message': 'E-Mail eingeben und weitermachen.',
        'character-limit-exceeded': 'Text überschreitet das {{limit}} Zeichen-Limit für anonyme Benutzer',
        'generations-remaining_one': 'Noch {{count}} Generierung heute',
        'generations-remaining_other': 'Noch {{count}} Generierungen heute',
        'create-account': 'Konto erstellen',
        email: 'E-Mail',
        'marketing-consent':
            'Ich willige ein, Marketing-E-Mails von CrispyVoice zu erhalten, u.a. zu neuen Stimmen, Features und Angeboten.',
        or: 'oder',
        'sign-in': 'Anmelden',
        'take-name': 'Version {{position}}',
        'available-languages': 'Verfügbare Sprachen',
        'advanced-options': 'Erweiterte Optionen',
        'reset-values': 'Werte zurücksetzen',
        speed: 'Geschwindigkeit',
        slower: 'langsamer',
        faster: 'schneller',
        stability: 'Stabilität',
        'more-variable': 'variabler',
        'more-stable': 'stabiler',
        similarity: 'Ähnlichkeit',
        'style-exaggeration': 'Stilübertreibung',
        none: 'keine',
        exaggerated: 'übersteigert',
        'speaker-boost': 'Sprecher-Boost',
        'speed-tooltip':
            'Steuert die Geschwindigkeit der generierten Sprache. Werte unter 1,0 verlangsamen, Werte über 1,0 beschleunigen. Extreme Werte können die Qualität beeinträchtigen.',
        'stability-tooltip':
            'Eine höhere Stabilität macht die Stimme zwischen Neugenerierungen konsistenter, kann aber monoton klingen. Für längere Texte empfehlen wir einen niedrigeren Wert.',
        'similarity-tooltip':
            'Eine hohe Verstärkung verbessert die Stimmklarheit und die Ähnlichkeit mit der Zielsprecherin/dem Zielsprecher. Sehr hohe Werte können Artefakte verursachen – finde einen optimalen Mittelwert.',
        'style-tooltip':
            'Hohe Werte betonen den Sprechstil stärker als im hochgeladenen Audio und können die Stabilität verringern. 0,0 beschleunigt die Generierung und ist der Standard.',
        'stability-warning': 'Unter 30 % kann zu Instabilität führen',
        'style-warning': 'Über 50 % kann zu Instabilität führen',
        'supported-languages':
            'Wir unterstützen 29 Sprachen: Englisch (USA, UK, Australien, Kanada), Japanisch, Chinesisch, Deutsch, Hindi, Französisch (Frankreich, Kanada), Koreanisch, Portugiesisch (Brasilien, Portugal), Italienisch, Spanisch (Spanien, Mexiko), Indonesisch, Niederländisch, Türkisch, Filipino, Polnisch, Schwedisch, Bulgarisch, Rumänisch, Arabisch (Saudi-Arabien, VAE), Tschechisch, Griechisch, Finnisch, Kroatisch, Malaiisch, Slowakisch, Dänisch, Tamil, Ukrainisch & Russisch.',
        characters: 'Zeichen',
        'voice-settings': 'Stimmeinstellungen',
        'apply-settings': 'Anwenden',
        'flagged-by-moderation': {
            'email-topic': 'CrispyVoice: Moderation Flag für Generierung mit ID {{jobId}}',
            'fixed-body-part': 'Text: {{text}}\nModerationsergebnis: {{moderationResult}}'
        },
        'flagged-contact-description':
            'Falls du der Meinung bist, dass unsere automatische Moderation hier einen Fehler gemacht hat, oder du der Meinung bist, dass ich diesen Text trotzdem erlauben soll, dann begründe dies bitte hier. Deinen Text brauchst du nicht nochmals wiederzugeben, er wird automatisch mit gesendet.',
        high: 'hoch',
        low: 'niedrig',
        'voice-settings-message': 'Passe die Stimme nach deinen Wünschen an.',
        'voice-settings-title': 'Stimmeinstellungen',
        'step-text': 'Schritt {{stepNumber}}/{{totalSteps}}: $t(audio-generation:steps.{{stepName}})',
        'queue-position_one': '{{count}} Job vor dir',
        'queue-position_other': '{{count}} Jobs vor dir',
        'time-text': 'Fertig in ~{{remainingSeconds}}s',
        'step-timeout-warning': 'Der aktuelle Schritt dauert länger als erwartet',
        steps: {
            IN_QUEUE: 'In Warteschlange',
            MODERATION: 'Inhaltsprüfung',
            GENERATION: 'Generierung',
            COMPLETE: 'Abgeschlossen'
        },
        continue: 'Freischalten',
        sending: 'Code wird gesendet...',
        'error-title': 'Konnte nicht generiert werden',
        'edit-to-continue': 'Bitte bearbeite deinen Text, um es erneut zu versuchen.',
        verify: 'Überprüfen',
        verifying: 'Wird überprüft...',
        'verification-code-sent':
            'Wir haben dir einen Code an {{email}} geschickt. Bitte gib ihn hier ein. Bitte prüfe auch deinen Spam-Ordner!',
        'verify-email-title': 'E-Mail verifizieren',
        'verification-code': 'Code',
        'verification-code-length': 'Der Verifizierungscode muss genau 6 Zeichen lang sein',
        'consent-required': 'Du musst dem Erhalt von Marketing-E-Mails zustimmen, um fortzufahren.',
        moderation: {
            'flagged-text-description':
                'Dieser Text wurde von unserer automatischen Moderation aus folgenden Gründen abgelehnt:',
            'please-rephrase': 'Wir können für diesen Text kein Audio generieren. Bitte formuliere ihn um.',
            'contact-support':
                'Falls du denkst, dass dies ein Fehler war oder du eine Ausnahme beantragen möchtest, dann kontaktiere mich bitte:'
        }
    },
    checkout: {
        header: 'Wähle deine Takes!',
        description:
            'Gleicher Text, verschiedene Takes – wähle und zahle nur was du brauchst. Hinweis: Bei identischem Text zahlst du nur einen Aufschlag pro Take. Ändert sich der Text um mehr als 5%, wird ein neues Modul berechnet. ',
        'no-recordings-yet': 'Bitte generiere zuerst einen Text, um hier etwas zu sehen!',
        play: 'Abspielen',
        stop: 'Stopp',
        'accept-terms': 'Ja, ich akzeptiere die <0>AGB</0><1/>.',
        'order-now': 'Jetzt bestellen',
        'voice-owner-approved': 'Voice Owner Approved',
        'allowed-medium': 'Verwendung',
        format: 'Format',
        'including-release-document': 'Inklusive Freigabedokument',
        'download-after-payment': 'Download direkt nach Bezahlung',
        columns: {
            version: 'Take',
            text: 'Text',
            buy: 'Kaufen',
            actions: ''
        },
        variants: 'Variante',
        variants_other: 'Varianten',
        takes_one: 'Take',
        takes_other: 'Takes',
        'line-item_zero': '{{speakerName}} – {{mediumTitle}}: {{textLength}} Zeichen',
        'line-item':
            '{{speakerName}} – {{mediumTitle}}: {{textLength}} Zeichen, inkl. {{count}} $t(checkout:variants, { "count": {{count}} })',
        'has-coupon': 'Ich habe einen Rabatt-Code!',
        'percentage-coupon': 'Rabatt: {{discount}}%',
        coupon: 'Code',
        cancel: 'Nein, Version behalten',
        confirmDeleteTake: 'Willst du diese Version wirklich löschen?',
        delete: 'Ja, löschen'
    },
    login: {
        meta: {
            title: 'Anmeldung',
            subTitle: 'CrispyVoice Kundenportal'
        },
        email: 'E-Mail-Adresse',
        password: 'Passwort',
        'remember-me': 'Eingeloggt bleiben',
        login: 'Einloggen',
        signIn: 'Anmelden',
        forgotPassword: 'Passwort vergessen?',
        createAnAccount: 'Jetzt registrieren',
        resetPassword: 'Passwort zurücksetzen',
        backToLogin: 'Zurück zur Anmeldung',
        checkYourEmail: 'Überprüfe deine E-Mails',
        emailVerificationCodeSent: 'Wir haben dir einen Code zur Bestätigung deiner E-Mail-Adresse gesendet.',
        newPassword: 'Neues Passwort',
        confirmNewPassword: 'Neues Passwort bestätigen'
    },
    onboarding: {
        emails: {
            welcome: {
                subject: 'Willkommen bei CrispyVoice!',
                heading: 'Willkommen bei CrispyVoice, {{user_name}}!',
                login: 'Hier einloggen'
            },
            password: {
                subject: 'CrispyVoice: Dein Account-Passwort',
                heading: 'Dein CrispyVoice Account-Passwort',
                'password-text': 'Hier ist dein initiales Passwort für deinen Account:',
                login: 'Hier einloggen',
                'change-it': 'Wir empfehlen dir dringend, es nach dem ersten Login zu ändern.'
            }
        }
    },
    footer: {
        gtc: 'Nutzungsbedingungen',
        imprint: 'Impressum',
        'contact-real-voice': 'Natürliche Stimme kontaktieren',
        copyright: 'Ⓒ CrispyVoice {{year}}'
    },
    navigation: {
        title: 'CrispyVoice-Portal',
        subTitle: 'Willkommen',
        home: 'Startseite',
        purchases: 'Käufe'
    },
    contact: {
        title: 'Kontakt',
        name: 'Name',
        email: 'E-Mail',
        message: 'Nachricht',
        submit: 'Nachricht senden',
        success: 'Nachricht gesendet!',
        'name-too-long': 'Bitte verwende einen kürzeren Namen',
        'message-required': 'Nachricht ist erforderlich',
        'message-too-short': 'Bitte gib mehr Details an (mindestens 20 Zeichen)',
        'message-too-long': 'Bitte kürze deine Nachricht auf maximal 500 Zeichen'
    },
    gtc: {
        heading: 'Allgemeine Geschäftsbedingungen (AGB) für Kunden von Voice Artists auf CrispyVoice ',
        text:
            '# 1. Geltungsbereich und Vertragsparteien\n1.1. Diese Allgemeinen Geschäftsbedingungen (nachfolgend "AGB") regeln das\nVertragsverhältnis zwischen mir als professioneller Sprecherin/professionellem\nSprecher (nachfolgend "Voice Artist") und Ihnen als Endkunden (nachfolgend "Kunde"),\nder meine mittels Künstlicher Intelligenz geklonte Stimme über die Plattform\nCrispyVoice (nachfolgend "Plattform") erwirbt.  \n1.2. Die Plattform CrispyVoice dient ausschließlich als technischer Dienstleister und\nVermittler zwischen mir und Ihnen. Ihr Vertragspartner bin ausschließlich ich als Voice\nArtist.  \n1.3. Mit der Bestellung einer KI-generierten Audiodatei mit meiner Stimme akzeptieren\nSie diese AGB in vollem Umfang.\n# 2. Leistungsbeschreibung\n2.1. Als Voice Artist biete ich über die Plattform die Erstellung von Audiodateien mit\nmeiner KI-geklonten Stimme an. Die Audiodateien werden basierend auf dem von Ihnen\neingereichten Text erstellt.  \n2.2. Die Audiodateien werden in MP3-Format mit 128 kbit/s in Mono-Qualität\nbereitgestellt.  \n2.3. Nach erfolgreicher Zahlung erhalten Sie einen Download-Link zur erstellten\nAudiodatei sowie einen einmaligen Identifikationscode, der dieser Datei zugeordnet ist.  \n2.4. Ich behalte mir das Recht vor, Texte, die gegen geltendes Recht verstoßen oder\nethisch bedenkliche Inhalte enthalten, abzulehnen. Die Überprüfung erfolgt\nautomatisiert durch KI-Systeme der Plattform.  \n# 3. Registrierung und Bestellprozess\n3.1. Für die Nutzung meiner KI-Stimme über die Plattform ist eine kostenlose\nRegistrierung erforderlich. Sie verpflichten sich, wahrheitsgemäße Angaben zu machen\nund Ihre Zugangsdaten vertraulich zu behandeln.  \n3.2. Der Bestellprozess umfasst folgende Schritte: a) Auswahl meiner Stimme b) Auswahl\ndes Verwendungszwecks und der entsprechenden Lizenz c) Eingabe des zu\nvertönenden Textes d) Auswahl der gewünschten Anzahl an Takes/Versionen e)\nÜberprüfung und Bestätigung der Bestellung f) Bezahlung g) Sofortiger Download der\ngenerierten Audiodatei  \n3.3. Sie erhalten unmittelbar nach erfolgreicher Bezahlung Zugang zur bestellten\nAudiodatei. Mit diesem Zeitpunkt gilt der Vertrag als erfüllt.\n# 4. Preise und Zahlungsbedingungen\n4.1. Die Preise für die verschiedenen Verwendungszwecke werden von mir als Voice\nArtist festgelegt und sind auf der Plattform transparent ausgewiesen.  \n4.2. Die Grundpreise umfassen eine gewisse Anzahl an Zeichen. Für jeden zusätzlichen Zeichen\nfallen die auf der Plattform angegebenen Zusatzkosten an.  \n4.3. Bei Bestellung mehrerer Takes oder Versionen des gleichen Textes wird ein\nprozentualer Aufschlag berechnet. Bei Textänderungen in weiteren Takes wird die\nLizenzgebühr doppelt berechnet, falls diese Option ausgewählt wurde.  \n4.4. Der Gesamtpreis wird Ihnen vor der finalen Bestellbestätigung deutlich angezeigt.  \n4.5. Die Bezahlung erfolgt ausschließlich über die angebotenen Zahlungsmethoden\n(Kreditkarte via Stripe or TWINT). Alle Zahlungen sind sofort fällig und werden vor\nBereitstellung der Audiodatei vollständig eingezogen.  \n4.6. Die Rechnungsstellung erfolgt über Stripe mit Ausweis der im jeweiligen Land des\nKunden gültigen Mehrwertsteuer, sofern ich als Voice Artist mehrwertsteuerpflichtig\nbin. Bei internationalen Transaktionen gilt der Mehrwertsteuersatz des Landes, in dem\nder Kunde seinen Sitz hat, sofern dies nach den geltenden Steuervorschriften\nerforderlich ist.  \n4.7. Für Kunden mit Sitz in der Europäischen Union: Bei Angabe einer gültigen\nUmsatzsteuer-Identifikationsnummer kann die Rechnung ohne Mehrwertsteuer\nausgestellt werden, sofern die gesetzlichen Voraussetzungen für eine\ninnergemeinschaftliche Leistung vorliegen.\n# 5. Lizenz- und Nutzungsrechte\n5.1. Mit dem Erwerb einer Audiodatei erhalten Sie von mir als Voice Artist ein nichtexklusives, nicht übertragbares Nutzungsrecht an der KI-generierten Stimme für den bei\nder Bestellung ausgewählten Verwendungszweck.  \n5.2. Die Lizenzdauer wird von mir als Voice Artist festgelegt und ist für jeden\nNutzungstyp während des Bestellvorgangs klar ausgewiesen. Die spezifische Dauer\nIhrer Lizenz ist in Ihrer Auftragsbestätigung dokumentiert und kann Folgendes\numfassen: a) Begrenzte Zeitdauer (z.B. 1 Jahr, 2 Jahre) b) Unbefristete Lizenz (zeitlich\nunbegrenzt) c) Individuelle Lizenzperioden gemäß spezifischer Angabe  \n5.3. Das Nutzungsrecht ist weltweit gültig, sofern von mir während des Bestellvorgangs\nnicht anders angegeben.  \n5.4. Sie sind nicht berechtigt: a) Die Audiodatei für andere als die erworbenen\nVerwendungszwecke zu nutzen b) Die Audiodatei an Dritte weiterzugeben oder zu\nverkaufen c) Die Audiodatei für das Training von Sprachmodellen oder KI-Systemen zu\nverwenden d) Die Audiodatei zu verändern oder zu bearbeiten e) Die Audiodatei für\nillegale, betrügerische oder rufschädigende Zwecke zu verwenden f) Die Audiodatei\nnach Ablauf der Lizenzperiode weiterhin zu nutzen (bei zeitlich begrenzten Lizenzen)  \n5.5. Bei Zuwiderhandlung gegen diese Bestimmungen erlischt das Nutzungsrecht\nautomatisch und ich behalte mir rechtliche Schritte vor.  \n5.6. Wenn Sie eine zeitlich begrenzte Lizenz verlängern oder die Nutzungsrechte ändern\nmöchten, müssen Sie eine neue Bestellung aufgeben oder mich direkt über die\nPlattform kontaktieren.  \n5.7. Bei kommerziellen Nutzungen sind Sie dafür verantwortlich, Aufzeichnungen darüber\nzu führen, wann und wie die Audiodatei verwendet wurde, um die Einhaltung der\nLizenzdauer zu gewährleisten.\n# 6. Kennzeichnung von KI-generierten Inhalten\n6.1. Jede erworbene Audiodatei erhält einen einmaligen Identifikationscode, der in einem\nFreigabedokument enthalten ist und zur eindeutigen Identifizierung der lizenzierten\nDatei dient.  \n6.2. Sie verpflichten sich, bei der Verwendung der Audiodatei die jeweils geltenden\ngesetzlichen und plattformspezifischen Kennzeichnungspflichten für KI-generierte\nInhalte einzuhalten.  \n6.3. Falls eine Plattform oder ein Medium, auf dem Sie die Audiodatei verwenden, eine\nspezifische Kennzeichnung von KI-generierten Inhalten vorschreibt, sind Sie\nverpflichtet, diese Kennzeichnung vorzunehmen. Der mit der Audiodatei gelieferte\neinmalige Identifikationscode kann für diesen Zweck verwendet werden.  \n6.4. Auf Anfrage stelle ich Ihnen eine Bestätigung zur Verfügung, dass Sie die Audiodatei\nrechtmäßig erworben und lizenziert haben.\n# 7. Gewährleistung und Haftung\n7.1. Als Voice Artist übernehme ich keine Gewähr für die inhaltliche Richtigkeit der von\nIhnen eingereichten Texte.  \n7.2. Reklamationen bezüglich der Qualität der KI-generierten Audiodateien sind\nausgeschlossen. Bei Buchung meiner natürlichen Stimme kann der bereits gezahlte\nBetrag nach meinem Ermessen angerechnet werden.  \n7.3. Meine Haftung als Voice Artist ist auf Vorsatz und grobe Fahrlässigkeit beschränkt.\nDie Haftung für leichte Fahrlässigkeit ist ausgeschlossen, soweit gesetzlich zulässig.  \n7.4. Ich hafte nicht für Schäden, die durch missbräuchliche oder rechtswidrige\nVerwendung der Audiodateien durch Sie entstehen.  \n7.5. Sie stellen mich als Voice Artist von allen Ansprüchen Dritter frei, die aus der\nNutzung der Audiodateien durch Sie entstehen könnten.  \n7.6. Die maximale Haftung ist in jedem Fall auf den von Ihnen gezahlten Kaufpreis\nbeschränkt.\n# 8. Datenschutz\n8.1. Ihre personenbezogenen Daten (Firma, Anschrift, Telefonnummer, E-Mail) werden\nausschließlich zum Zweck der Vertragsabwicklung und gemäß den geltenden\nDatenschutzbestimmungen erhoben und verarbeitet.  \n8.2. Die Daten werden auf Servern von AWS und Hetzner in den USA und in Europa gespeichert. Sie erklären sich\nmit dieser Speicherung ausdrücklich einverstanden.  \n8.3. Die von Ihnen eingereichten Texte werden ausschließlich zur Erstellung der\nAudiodateien verwendet und sind nur für mich als Voice Artist einsehbar.  \n8.4. Die erstellten Audiodateien werden unbegrenzt gespeichert und bleiben für Sie zum\nDownload verfügbar.  \n8.5. Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Löschung und\nEinschränkung der Verarbeitung Ihrer personenbezogenen Daten. Entsprechende\nAnfragen sind an meine Kontakt-E-Mail zu richten.\n# 9. Urheberrecht und geistiges Eigentum\n9.1. Das KI-Modell zur Generierung der Stimme ist geistiges Eigentum von CrispyVoice.  \n9.2. Die Persönlichkeitsrechte an meiner Originalstimme verbleiben bei mir als Voice\nArtist.  \n9.3. Sie erwerben ausschließlich die in Abschnitt 5 definierten Nutzungsrechte an der\ngenerierten Audiodatei.  \n9.4. Sie sind verpflichtet, bei der Nutzung der Audiodateien alle anwendbaren\nUrheberrechts- und Persönlichkeitsrechtsbestimmungen zu beachten.\n# 10. Vertragslaufzeit und Kündigung\n10.1. Der Vertrag zwischen mir als Voice Artist und Ihnen endet mit der Bereitstellung der\nAudiodatei, die Nutzungsrechte bestehen gemäß den in Abschnitt 5 genannten\nBedingungen fort.  \n10.2. Ich bin berechtigt, die Nutzungsrechte mit sofortiger Wirkung zu entziehen, wenn\nSie gegen diese AGB verstoßen, insbesondere wenn die Audiodateien für rechtswidrige\noder rufschädigende Zwecke verwendet werden.\n# 11. Änderungen der AGB\n11.1. Ich behalte mir das Recht vor, diese AGB jederzeit zu ändern. Änderungen werden\nIhnen per E-Mail oder über den Newsletter mitgeteilt.  \n11.2. Sie werden über Änderungen am Stimmmodell oder an den Nutzungsbedingungen\nper Newsletter informiert, sofern Sie diesen abonniert haben.  \n11.3. Für bereits erworbene Audiodateien gelten die zum Zeitpunkt des Kaufs gültigen\nAGB.\n# 12. Streitbeilegung\n12.1. Bei Streitigkeiten aus oder im Zusammenhang mit diesem Vertrag verpflichten wir\nuns, zunächst eine einvernehmliche Lösung anzustreben. Beanstandungen und\nReklamationen richten Sie bitte direkt an mich als Voice Artist unter der angegebenen\nKontakt-E-Mail.  \n12.2. Ich werde auf Ihre Beanstandung innerhalb von 14 Tagen reagieren und eine Lösung\nvorschlagen.  \n12.3. Sollte keine Einigung erzielt werden können, kann vor Beschreitung des Rechtswegs\neine Mediation nach den Regeln der Schweizerischen Kammer für Wirtschaftsmediation\n(SKWM) oder des Schweizerischen Dachverbands Mediation (SDM) durchgeführt\nwerden. Die Kosten der Mediation werden von beiden Parteien zu gleichen Teilen\ngetragen, sofern keine andere Vereinbarung getroffen wird.\n# 13. Schlussbestimmungen\n13.1. Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die\nWirksamkeit der übrigen Bestimmungen davon unberührt.  \n13.2. Es gilt ausschließlich das Recht des Landes, in dem ich als Voice Artist meinen\nWohnsitz habe, unter Ausschluss des UN-Kaufrechts.  \n13.3. Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist\nmein Wohnsitz als Voice Artist, soweit gesetzlich zulässig.  \n13.4. Diese AGB wurden zuletzt aktualisiert am [01.05.2025].'
    },
    emails: {
        'anonymous-registration': {
            subject: 'Dein Code für unbegrenztes Generieren',
            greeting: 'Hi!',
            'code-text': 'Fast fertig - hier ist dein Code:',
            'explanation-text': 'Einfach ins Feld eingeben und unbegrenzt weitermachen.',
            'expiration-text': 'Code gültig für 10 Minuten.',
            'there-you-go': 'Und bitte!'
        }
    }
};
